import React from "react";

export const Footer = () => {
  return (
    <footer className="container bottom-0 left-0 right-0 text-center">
      <p className="float-end animate-bounce" style={{ cursor: "pointer" }}></p>
      <p>
        &copy; 2022–{new Date().getFullYear()} Andrew's Cookin' &middot;{" "}
        <a href="/privacy-conditions/">Privacy</a> &middot;{" "}
        <a href="/terms-and-conditions/">Terms</a> &middot;{" "}
        <a href="/contacts/">Contact Info</a> &middot;{" "}
      </p>
    </footer>
  );
};
